import React, { useCallback } from 'react';
import { FdrProductRecommender } from 'components/domain/fdr-page-components/recommenders/product/fdr-product-recommender';
import { IFdrProductRecommenderComponent } from 'components/domain/fdr-page-components/recommenders/product/fdr-product-recommender.types';
import useFdrPageComponentsFetch from 'components/domain/fdr-page-components/useFdrPageComponentsFetch';
import { ProductRecommendationView } from 'components/domain/recommendations/Recommendations.constants';
import { FdrThemeGeoPaginatedProductsDocument } from 'schemas/query/theme-geo/fdr-theme-geo-paginated-products.generated';
import { mapThemeGeoProductResponseToProducts } from './fdr-theme-geo.utils';

interface IFdrThemeGeoProductRecommenderProps {
  geoId: string;
  themeId: string;
  component: IFdrProductRecommenderComponent;
}

const FdrThemeGeoProductRecommender: React.FC<IFdrThemeGeoProductRecommenderProps> =
  ({ geoId, themeId, component }) => {
    const mapVariables = useCallback(
      (page, perPage) => {
        return {
          input: { geoId, themeId },
          pagination: {
            page,
            perPage,
          },
        };
      },
      [geoId, themeId]
    );

    const { fetchItems, loading } = useFdrPageComponentsFetch(
      FdrThemeGeoPaginatedProductsDocument,
      mapVariables,
      mapThemeGeoProductResponseToProducts
    );

    return (
      <FdrProductRecommender
        component={component}
        view={ProductRecommendationView.GRID}
        fetchItems={fetchItems}
        loading={loading}
      />
    );
  };

export default FdrThemeGeoProductRecommender;
